import { saveCensusWarning } from "../api/setFormData";
import _ from 'lodash'
import { monthNumberToMonth, licenseValidationList, steelAndAluminiumHts} from  '../formSections/util/constants'
import { idOptionsvvValidation } from "../util/supportedFields/importer";
import { merchandiseListToTotalAmount, getCommodityHTSOrPrimaryCommodity } from "../formSections/util/";
import { isBusinessDayMemoized } from "kx-common-components"
import EntrySummaryForm from "../formSections/index"; 
import { getQueryVariable } from "../../apiCalls/jobInfo";
import { PSCIsAlreadyFiledPSCSTATES } from "../formSections/declarationSection";
import { ch82SetHtses, isWarehouseEntry, sumGrossWeight } from "./util";
/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */
/*
formsections/index:
warningsName_la
"Merchandise
Parties
Entry
Transport
Bol
Sign"
*/
const initialState = {
  // initialValues
}

export function zipCodeValidator(countryNameInput, zipValueInput){
  let countryName = (countryNameInput||"").toUpperCase().trim();
  let zipValue = (zipValueInput||"").replaceAll(/[^\d]/g,"");
  let errorArray = [];
  if(countryName == "CHINA" || countryName == "CN"){
    if(!zipValue || zipValue.length === 0){
      errorArray.push((fieldName)=>{return `Postal Code: ${fieldName} is missing a Postal Code for Country ${countryName}`})
    }
    else if(!(/^[0-9]{6}$/).test(zipValue)){
      errorArray.push((fieldName)=>{return `Postal Code: ${fieldName} must be 6 digits for Country ${countryName} - NNNNNN`});
    }
  }
  return errorArray;
}

function validateFormff(myobj,allpropsaa) {
  if((window.LAST_WARNING_FF?.whennnn||0)+1500 > Date.now()){
    return {...window.LAST_WARNING_FF,whennnn:null};
  }
  const hasFieldKN = (stringInput) => {
    if(stringInput == -999)return false; 
    if(stringInput == "_BLANK_")return false;
    if(stringInput == "N/A")return false;
    return !!((stringInput||"")+"").trim();
  }

  console.log('--store.getState(): ', myobj);
  let isDisabled =  (new EntrySummaryForm.WrappedComponent())?.isDisabled;
  let transitinfoasnum = parseInt(myobj.TransportationInfo.modeOfTransport) || myobj.TransportationInfo.modeOfTransport;
  let isAir = transitinfoasnum == 40 || transitinfoasnum ==41 || transitinfoasnum === "MOT_AIR";
  let isTruck = transitinfoasnum == 30 || transitinfoasnum ==31 || transitinfoasnum === "MOT_TRUCK";
  let isRail = transitinfoasnum == 20 || transitinfoasnum ==21 || transitinfoasnum === "MOT_RAIL" || transitinfoasnum === "MOT_RAIL_CONTAINER";
  let isOcean = transitinfoasnum ==11 || transitinfoasnum === "MOT_OCEAN"  || transitinfoasnum === "MOT_OCEAN_NON_CONTAINER";
  let CURRENCY_CONVERSION_MATH_ERROR_MARGIN = 2;
  var warningListyy = [];
  var validObjects_bl = {};
  var entryType = myobj.EntryTypeInfo.entryType;
  const feeIsZero = (userFee)=>{
    return userFee.disclaim != 1 && 
    (!userFee.feeValue ||
      userFee.feeValue == 0 ||
      userFee.feeValue == '-999' ||
      userFee.feeValue == '');
  }
      
  let isblank = (str)=>{
    if(typeof str !== "string")return false;
    return !str || str.trim() === ""
  }
  
  if(!myobj)return warningListyy;
  // if((myobj.DescriptionOfMerchandise.grossWeight.weight+"").length> 10){
  //   // warningListyy.push({tab:"Merchandise",msg:"Top level: Weight cannot be more than 10 characters:"+myobj.DescriptionOfMerchandise.grossWeight.weight,name:'grossWeight'});
    
  // } else 
  
  
  if(!myobj?.DescriptionOfMerchandise?.entrySummaryInvoices)return warningListyy;

  const merchCount = myobj?.DescriptionOfMerchandise?.entrySummaryInvoices.reduce(
    (accumulator, currentValue) => accumulator + currentValue.merchandiseLineItems.length,
    0,
  );
  // myobj?.DescriptionOfMerchandise?.entrySummaryInvoices.reduce(
    
  //   (accumulator, currentValue) => accumulator + currentValue,
  //   initialValue,
  // );
  const totalLineItemWeight = sumGrossWeight(myobj?.DescriptionOfMerchandise?.entrySummaryInvoices || []);
  
  if(!(myobj?.DescriptionOfMerchandise?.grossWeight?.weight || "").trim()){
    warningListyy.push({tab:"Merchandise",msg:"Top level: Weight cannot be empty",name:'grossWeight'});
  } else if(myobj.DescriptionOfMerchandise.grossWeight?.weight && totalLineItemWeight
    && Math.abs(totalLineItemWeight - myobj.DescriptionOfMerchandise.grossWeight.weight) > merchCount 
    && Math.abs(parseFloat(myobj.DescriptionOfMerchandise.grossWeight.weight * 0.453592).toFixed() - totalLineItemWeight) > merchCount){
    warningListyy.push({tab:"Merchandise",targetName_c: 'adcvdtggtGrossWeight',msg:`Gross weight and totalled line weight do not appear to be equal`});

    
  } 
  
  if((myobj.DescriptionOfMerchandise.mpf.fee+"").length> 8){
    warningListyy.push({tab:"Merchandise",msg:"MPF cannot be more than 8 characters:"+myobj.DescriptionOfMerchandise.mpf.fee,name:'mpf'});
  }
    
  if(!(myobj.DescriptionOfMerchandise.mpf.fee+"").trim()){
    warningListyy.push({tab:"Merchandise",msg:"MPF cannot be empty",name:'mpf'});
  }
  if( (myobj.DescriptionOfMerchandise.hmf.fee+"").length> 8){
    warningListyy.push({tab:"Merchandise",msg:"HMF  cannot be more than 8 characters:"+myobj.DescriptionOfMerchandise.hmf.fee,name:'hmf'});
  }
  if(!(myobj.DescriptionOfMerchandise.hmf.fee+"").trim()){
    warningListyy.push({tab:"Merchandise",msg:"HMF cannot be empty",name:'hmf'});
  }

  // if((myobj.DescriptionOfMerchandise.manufacturerId+"").length> 15){
  //   warningListyy.push({tab:"Merchandise",msg:"Manufacturer ID cannot be more than 15 characters:"+myobj.DescriptionOfMerchandise.manufacturerId,name:'manufacturerId'});
  // }
  // if(!(myobj.DescriptionOfMerchandise.manufacturerId+"").trim()){
  //   warningListyy.push({tab:"Merchandise",msg:"Manufacturer ID cannot be empty",name:'manufacturerId'});
  // }
  let intdddex = 0;
  if(myobj.DescriptionOfMerchandise.entrySummaryInvoices){
    for(var item  of  myobj.DescriptionOfMerchandise.entrySummaryInvoices){
      let invoiceitemid = " (Invoice "+(''+(++intdddex)).padStart(3, '0')+")";
      let invoiceId = item.invoiceId;
      let _intdddex = 0;
      
      if(!hasFieldKN(item.invoiceNumber)){
        warningListyy.push({tab:"Merchandise",msg:`Invoice Number: Missing Invoice Number`, 
        targetName_c: 'adcvdtggt'+invoiceId,name:'invoiceNumber'+invoiceId, invoice: `invoice-${invoiceId}`, priorityErrorFinalReview: true});
      }
      if(!hasFieldKN(parseInt(item.invoiceDate))){
        warningListyy.push({tab:"Merchandise",msg:`Invoice Date: Missing Invoice Date`, 
        targetName_c: 'adcvdtggt'+invoiceId,name:'invoiceDate'+invoiceId, invoice: `invoice-${invoiceId}`, priorityErrorFinalReview: true});
      }
      if(item && item.currencyExchangeInfo){
        if(item.currencyExchangeInfo.exchangeRate && parseFloat(item.currencyExchangeInfo.exchangeRate) <= 0 ){
          warningListyy.push({tab:"Merchandise",msg:`Currency Exchange: Exchange rate must be greater than 0, was ${item.currencyExchangeInfo.exchangeRate}`, 
          targetName_c: 'adcvdtggt'+invoiceId,name:'exchangeRate', invoice: `invoice-${invoiceId}`});

        }
        if(!item.currencyExchangeInfo.fromIsoCurrencyCode){
          warningListyy.push({tab:"Merchandise",msg:"Currency Exchange: Missing currency", 
          targetName_c: 'adcvdtggt'+invoiceId,name:'invoiceAmount', invoice: `invoice-${invoiceId}`});

        }
        
      } else {
        // warningListyy.push({tab:"Merchandise",msg:"Currency Exchange: Missing currency information", 
        // targetName_c: 'adcvdtggt'+invoiceId,name:'invoiceAmount', invoice: `invoice-${invoiceId}`});
        
      }
      if(item.merchandiseLineItems.length == 0){
        warningListyy.push({tab:"Merchandise",msg:"Invoice Item: Has no merchandise. Must have merchandise line item", location: invoiceitemid, 
        targetName_c: 'adcvdtggt'+invoiceId, invoice: `invoice-${invoiceId}`});

      }

      
      if(item?.currencyExchangeInfo?.exchangeRate && item?.currencyExchangeInfo?.fromIsoCurrencyCode!="USD"){
        if((myobj?.TransportationInfo?.exportDate?.epochs || 0) > Date.now()){
          warningListyy.push({tab:"Merchandise",msg:`Exchange Rate: You are trying to file an entry where Export Date is in the future.  Are you sure you want to use Currency Exchange from today?`, location: invoiceitemid, 
          targetName_c: 'adcvdtggt'+invoiceId,
          boldThisPart: ["today?"],
          invoice: `exchangeRate-${invoiceId}`});
          
        }
      }

      if(item?.currencyExchangeInfo?.exchangeRate && item?.currencyExchangeInfo?.toIsoCurrencyCode!="USD"){
        let foreignvalUnfixed = merchandiseListToTotalAmount(item.merchandiseLineItems);
          let unusedDutyValues = 0;//((item.merchandiseLineItems||[]).map(a=>a.merchandiseDuties)||[]).flat().filter(a=>a&&a.isCommodityDuty == 2).map(a=>a.enteredValue).reduce((a,b)=>parseFloat(a||0)+parseFloat(b||0),0)
          let differenceBetweenShownAndCalculatedInvoice = Math.abs((foreignvalUnfixed * item?.currencyExchangeInfo?.exchangeRate) - (item.invoiceAmount - unusedDutyValues));
          if(differenceBetweenShownAndCalculatedInvoice > CURRENCY_CONVERSION_MATH_ERROR_MARGIN){
            warningListyy.push({tab:"Merchandise",msg:`Invoice Converted Value: Calculation appears incorrect ${foreignvalUnfixed} * ${item?.currencyExchangeInfo?.exchangeRate} = ${item.invoiceAmount - unusedDutyValues}, off by ${Math.round(differenceBetweenShownAndCalculatedInvoice)}`, location: invoiceitemid, 
            targetName_c: 'adcvdtggt'+invoiceId, invoice: `invoice-${invoiceId}`});

          }
      }

      for(var commercialItem of item.merchandiseLineItems){
        let merchid = commercialItem.merchandiseId;
        let merchlineitemid = invoiceitemid+" (Line item "+(''+(++_intdddex)).padStart(3, '0')+")";
        if(!(commercialItem.commercialDescription)){
          warningListyy.push({tab:"Merchandise",msg:"Commercial Description: Cannot be empty", location: merchlineitemid, 
          targetName_c: 'adcvdtggt'+merchid,name:'commercialDescription'+merchid, invoice: `invoice-${invoiceId}`});
        }
        if(!commercialItem.productClaimCode || ['_BLANK_',-999,'NONE'].includes(commercialItem.productClaimCode) 
          && allpropsaa?.updateType != 'cargoReleaseUpdate'){
          warningListyy.push({tab:"Merchandise",msg:"Trade Agreement/Special Program: Make a selection", location: merchlineitemid, 
          targetName_c: 'adcvdtggt'+merchid,name:'productClaimCode'+merchid, invoice: `invoice-${invoiceId}`, priorityErrorFinalReview: true});

        };
        // if((commercialItem.commercialDescription+"").length > 35){
        //   warningListyy.push({tab:"Merchandise",msg:"Commercial Description: Cannot be more than 35 characters:"+commercialItem.commercialDescription, location: merchlineitemid, 
        //   targetName_c: 'adcvdtggt'+merchid,name:'commercialDescription'+merchid, invoice: `invoice-${invoiceId}`});
        // }
        let invalidCharactersRegex = /[?]/
        const regexMatch = commercialItem.commercialDescription?.match(invalidCharactersRegex)
        if(regexMatch){
          warningListyy.push({tab:"Merchandise",msg:"Commercial Description: Cannot have special characters: "+regexMatch[0], location: merchlineitemid, 
          targetName_c: 'adcvdtggt'+merchid,name:'commercialDescription'+merchid, invoice: `invoice-${invoiceId}`});
        }
        if(!commercialItem.countryOfOrigin){
          warningListyy.push({tab:"Merchandise",msg:"Country of Origin: Cannot be empty", location: merchlineitemid, 
          targetName_c: 'adcvdtggt'+merchid,name:'countryOfOrigin'+merchid, invoice: `invoice-${invoiceId}`});
  
        } else if((commercialItem.countryOfOrigin+"").trim() == 'CA'){
          warningListyy.push({tab:"Merchandise",msg:"Country of Origin: Canada is invalid. Select a Canadian province instead.", location: merchlineitemid, 
          targetName_c: 'adcvdtggt'+merchid,name:'countryOfOrigin'+merchid, invoice: `invoice-${invoiceId}`});

        }
        if(!commercialItem.manufacturerId){
          warningListyy.push({tab:"Merchandise",msg:"Manufacturer Id: Cannot be empty", location: merchlineitemid, 
          targetName_c: 'adcvdtggt'+merchid,name:'manufacturerId'+merchid, invoice: `invoice-${invoiceId}`});
  
        }
        let manufacturerexistsinpartiestab = false;
        for(let headerParty of myobj.Importer.headerParties || []){
          manufacturerexistsinpartiestab |= commercialItem.manufacturerHeaderIdUnderPartiesTab == headerParty.headerId;
        }
        if(!manufacturerexistsinpartiestab){
          let matchingmanufacturer = (myobj.Importer.headerParties||[]).find(a=>(a.mId+"").toUpperCase() == (commercialItem.manufacturerId+"").toUpperCase());
          if(!commercialItem.manufacturerId){//no mid whatsoever
            warningListyy.push({tab:"Merchandise",msg:"Manufacturer Id: No associated manufacturer", location: merchlineitemid, 
            targetName_c: 'adcvdtggt'+merchid,name:'manufacturerId'+merchid, invoice: `invoice-${invoiceId}`});
          } else  if(matchingmanufacturer){//mid is in both parties and line item. However we want to use the manufacturerHeaderIdUnderPartiesTab so this is wrong
            warningListyy.push({tab:"Merchandise",msg:`Manufacturer Id: Please reselect the MID field on line item from list before proceeding`, location: merchlineitemid, 
            targetName_c: 'adcvdtggt'+merchid,name:'manufacturerId'+merchid, invoice: `invoice-${invoiceId}`, warntype:'warning'});
          } else {//we have a mid that isn't on the parties tab
            warningListyy.push({tab:"Merchandise",msg:`Manufacturer Id: Manufacturer cannot be found on parties tab. Using manufacturer Id '${commercialItem.manufacturerId}''`, location: merchlineitemid, 
            targetName_c: 'adcvdtggt'+merchid,name:'manufacturerId'+merchid, invoice: `invoice-${invoiceId}`});
          }

        }
        if(!commercialItem.grossWeight.weight || commercialItem.grossWeight.weight == 0){
          warningListyy.push({tab:"Merchandise",msg:"Item weight: Cannot be Empty or Zero "+commercialItem.grossWeight.weight, location:merchlineitemid,
          targetName_c: 'adcvdtggt'+merchid,name:'grossWeight'+merchid, invoice: `invoice-${invoiceId}`});
        }
        if(!(commercialItem.grossWeight.weight+"").trim()){
          warningListyy.push({tab:"Merchandise",msg:"Item weight: Cannot be empty"+merchlineitemid,
          targetName_c: 'adcvdtggt'+merchid,name:'grossWeight'+merchid, invoice: `invoice-${invoiceId}`});
        }
        if(!['KG', 'LB'].includes((commercialItem.grossWeight.weightUnits+"").toUpperCase())){
          warningListyy.push({tab:"Merchandise",msg:"Item weight unit: Must be KG or LB, was "+commercialItem.grossWeight.weightUnits+" "+merchlineitemid,
          targetName_c: 'adcvdtggt'+merchid,name:'grossWeight'+merchid, invoice: `invoice-${invoiceId}`});

        }
        if((commercialItem.countryOfOrigin+"").length > 3){
          warningListyy.push({tab:"Merchandise",msg:"Invalid Country code:"+commercialItem.countryOfOrigin, location:merchlineitemid,
          targetName_c: 'adcvdtggt'+merchid,name:'countryOfOrigin'+merchid, invoice: `invoice-${invoiceId}`});
        }
        
        if(commercialItem.permitTypeCode && commercialItem.permitTypeCode!='_BLANK_'){
          if(!commercialItem.permitNumber || commercialItem.permitNumber.length === 0){
            warningListyy.push({tab:"Merchandise",msg:`Permit Number is blank`, location:merchlineitemid,
            targetName_c: 'adcvdtggt'+merchid,name:'permitNumber'+merchid, invoice: `invoice-${invoiceId}`});
          }
          else if(licenseValidationList[commercialItem.permitTypeCode]){
            let {regex, message} = licenseValidationList[commercialItem.permitTypeCode];
            if(regex && !commercialItem.permitNumber.match(regex)){
              warningListyy.push({tab:"Merchandise",msg:`Permit Number: ${message} Was ${commercialItem.permitNumber}`, location:merchlineitemid,
              targetName_c: 'adcvdtggt'+merchid,name:'permitNumber'+merchid, invoice: `invoice-${invoiceId}`});
            }
          }
        }

        if(commercialItem.importerAdditionalDeclarationDetails && commercialItem.importerAdditionalDeclarationDetails.importerAdditionalDeclarationDetail){
          const steelMeltAndPourDetailsTemp = commercialItem.importerAdditionalDeclarationDetails.importerAdditionalDeclarationDetail.find(detail => detail.typeCode === "STEEL_MELT_AND_POUR_COUNTRY_DETAIL")
          const steelMeltAndPourDetails = steelMeltAndPourDetailsTemp?.steelMeltAndPourCountryDetail
          if(steelMeltAndPourDetails?.countryOfMeltAndPour == "yes"){
            if(!hasFieldKN(steelMeltAndPourDetails.countryOfMeltAndPourCode) && steelMeltAndPourDetails.countryOfMeltAndPourApplicabilityCode != "yes"){
              warningListyy.push({tab:"Merchandise",msg:`Steel melt and pour: Must have a country or mark 'Does not apply'`, location:merchlineitemid, 
              targetName_c: 'adcvdtggt'+merchid, name:'countryOfMeltAndPourCode'+merchid, invoice: `invoice-${invoiceId}`,
               priorityErrorFinalReview: true
              });
            
            }
          }
          
          const aluminiumSmeltAndCastDetails = commercialItem.importerAdditionalDeclarationDetails.importerAdditionalDeclarationDetail.find(detail => detail.typeCode === "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL")
          if(aluminiumSmeltAndCastDetails && (aluminiumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.countryOfCast === "N/A" || aluminiumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.countryOfCast.length === 0)){
            warningListyy.push({tab:"Merchandise",msg:`Country of Cast cannot be empty`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'countryOfCast'+merchid, invoice: `invoice-${invoiceId}`
            ,priorityErrorFinalReview: true
            });
          }
          if(aluminiumSmeltAndCastDetails && aluminiumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isUsProduct === "no"){
            if(aluminiumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isPrimaryCountryOfSmeltApplied === "yes" && (aluminiumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.primaryCountryOfSmelt === "N/A" || aluminiumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.primaryCountryOfSmelt.length === 0)){
              warningListyy.push({tab:"Merchandise",msg:`Primary Country of Smelt cannot be empty`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'primaryCountryOfSmelt'+merchid, invoice: `invoice-${invoiceId}`, priorityErrorFinalReview: true});
            }
            if(aluminiumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isSecondCountryOfSmeltApplied === "yes" && (aluminiumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.secondaryCountryOfSmelt === "N/A" || aluminiumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.secondaryCountryOfSmelt.length === 0)){
              warningListyy.push({tab:"Merchandise",msg:`Secondary Country of Smelt cannot be empty`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'secondaryCountryOfSmelt'+merchid, invoice: `invoice-${invoiceId}`, priorityErrorFinalReview: true});
            }
            if(aluminiumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isPrimaryCountryOfSmeltApplied === "no" &&  aluminiumSmeltAndCastDetails.aluminumSmeltAndCastCountryDetail.isSecondCountryOfSmeltApplied === "no"){
              warningListyy.push({tab:"Merchandise",msg:`Primary Country or secondary country must apply`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'primaryCountryOfSmelt'+merchid, invoice: `invoice-${invoiceId}`, priorityErrorFinalReview: true});
              warningListyy.push({tab:"Merchandise",msg:`Primary Country or secondary country must apply`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'secondaryCountryOfSmelt'+merchid, invoice: `invoice-${invoiceId}`, priorityErrorFinalReview: true});
            }
          }
          const cbmaDeclationDetails = commercialItem.importerAdditionalDeclarationDetails.importerAdditionalDeclarationDetail.find(detail => detail.typeCode === "CBMA_PRODUCT_DETAIL")
          if(cbmaDeclationDetails){
            const foreignProducerIdentifierRegex = /TTB\-FP\-[A-HJKLMNP-Z0-9]{7}$/i ;  //O and I are not allowed
            const rateCodeRegex = /[a-zA-Z0-9]{6}$/
            if(!cbmaDeclationDetails.cbmaDeclarationDetail.foreignProducerIdentifier || cbmaDeclationDetails.cbmaDeclarationDetail.foreignProducerIdentifier.length === 0){
              warningListyy.push({tab:"Merchandise",msg:`FOREIGN PRODUCER TTB ID cannot be empty`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'foreignProducerIdentifier'+merchid, invoice: `invoice-${invoiceId}`});
            }
            else if(cbmaDeclationDetails.cbmaDeclarationDetail.foreignProducerIdentifier && !foreignProducerIdentifierRegex.test(cbmaDeclationDetails.cbmaDeclarationDetail.foreignProducerIdentifier)){
              warningListyy.push({tab:"Merchandise",msg:`FOREIGN PRODUCER TTB ID must match the format TTB-FP-XXXXXXX where X are alphanumerics excluding O and I.`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'foreignProducerIdentifier'+merchid, invoice: `invoice-${invoiceId}`});
            }
            if(!cbmaDeclationDetails.cbmaDeclarationDetail.foreignProducerName || cbmaDeclationDetails.cbmaDeclarationDetail.foreignProducerName.length === 0){
              warningListyy.push({tab:"Merchandise",msg:`FOREIGN PRODUCER Name cannot be empty`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'foreignProducerName'+merchid, invoice: `invoice-${invoiceId}`});
            }
            else if(cbmaDeclationDetails.cbmaDeclarationDetail.foreignProducerIdentifier && cbmaDeclationDetails.cbmaDeclarationDetail.foreignProducerIdentifier.length > 21){
              warningListyy.push({tab:"Merchandise",msg:`FOREIGN PRODUCER Name exceeds length (21)`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'foreignProducerName'+merchid, invoice: `invoice-${invoiceId}`});
            }
            if(!cbmaDeclationDetails.cbmaDeclarationDetail.rateCode || cbmaDeclationDetails.cbmaDeclarationDetail.rateCode.length === 0){
              warningListyy.push({tab:"Merchandise",msg:`RATE CODE cannot be empty`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'rateCode'+merchid, invoice: `invoice-${invoiceId}`});
            }
            else if(cbmaDeclationDetails.cbmaDeclarationDetail.rateCode && (cbmaDeclationDetails.cbmaDeclarationDetail.rateCode.length > 6 || !rateCodeRegex.test(cbmaDeclationDetails.cbmaDeclarationDetail.rateCode))){
              warningListyy.push({tab:"Merchandise",msg:`RATE CODE must be 6 characters.`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'rateCode'+merchid, invoice: `invoice-${invoiceId}`});
            }
            if(!cbmaDeclationDetails.cbmaDeclarationDetail.taxRate || cbmaDeclationDetails.cbmaDeclarationDetail.taxRate.length === 0){
              warningListyy.push({tab:"Merchandise",msg:`TTB TAX RATE cannot be empty`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'taxRate'+merchid, invoice: `invoice-${invoiceId}`});
            }
            else if(cbmaDeclationDetails.cbmaDeclarationDetail.taxRate && cbmaDeclationDetails.cbmaDeclarationDetail.taxRate.length > 8){
              warningListyy.push({tab:"Merchandise",msg:`TTB TAX RATE exceeds length (8).`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'taxRate'+merchid, invoice: `invoice-${invoiceId}`});
            }
            else if(cbmaDeclationDetails.cbmaDeclarationDetail.taxRate && isNaN(cbmaDeclationDetails.cbmaDeclarationDetail.taxRate)){
              warningListyy.push({tab:"Merchandise",msg:`TTB TAX RATE must be numeric.`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'taxRate'+merchid, invoice: `invoice-${invoiceId}`});
            }
          }

          const softwoodLumberDetails = commercialItem.importerAdditionalDeclarationDetails.importerAdditionalDeclarationDetail.find(detail => detail.typeCode === "SOFTWOOD_LUMBER_EXPORT")
          if(softwoodLumberDetails){
            if(!softwoodLumberDetails.softwoodLumberDetail.exportPrice || softwoodLumberDetails.softwoodLumberDetail.exportPrice.length === 0 || softwoodLumberDetails.softwoodLumberDetail.exportPrice === "-999"){
              warningListyy.push({tab:"Merchandise",msg:`Export Price cannot be empty`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'exportPrice'+merchid, invoice: `invoice-${invoiceId}`});
            }
            else if(softwoodLumberDetails.softwoodLumberDetail.exportPrice && softwoodLumberDetails.softwoodLumberDetail.exportPrice.length > 10){
              warningListyy.push({tab:"Merchandise",msg:`Export Price  exceeds length (10)`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'exportPrice'+merchid, invoice: `invoice-${invoiceId}`});
            }
            if(!softwoodLumberDetails.softwoodLumberDetail.exportCharge || softwoodLumberDetails.softwoodLumberDetail.exportCharge.length === 0 || softwoodLumberDetails.softwoodLumberDetail.exportCharge === "-999"){
              warningListyy.push({tab:"Merchandise",msg:`Export Charge cannot be empty`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'exportCharge'+merchid, invoice: `invoice-${invoiceId}`});
            }
            else if(softwoodLumberDetails.softwoodLumberDetail.exportCharge && softwoodLumberDetails.softwoodLumberDetail.exportCharge.length > 10){
              warningListyy.push({tab:"Merchandise",msg:`Export Charge exceeds length (10)`, location:merchlineitemid, targetName_c: 'adcvdtggt'+merchid, name:'exportCharge'+merchid, invoice: `invoice-${invoiceId}`});
            }
          }
        }
      }
    }
 
//PSC
if(document.getElementById("PSCinProgressYes") && !PSCIsAlreadyFiledPSCSTATES.includes(allpropsaa?.pscState?.value?.state)){//TODO: This should be in redux
    if(!myobj.PSC.pscFileExplanation){
      warningListyy.push({tab:"Sign",msg:"Missing PSC explanation"});
    }
    if(!myobj.PSC.accelaratedLiquidation){
      warningListyy.push({tab:"Sign",msg:"Set accelerated liquidation"});
    }
    if(myobj.PSC.confirmPSC != '1'){
      warningListyy.push({tab:"Sign",msg:"Must confirm PSC"});
    }

  }
  if(myobj.PSC && myobj.PSC.headerCodes ){
    for (let headerCodeone of myobj.PSC.headerCodes) {
      for (let headerCodetwo of myobj.PSC.headerCodes) {
        if (headerCodetwo.key == headerCodeone.key) continue;
        let repeatedPSCCode = _.intersection(headerCodetwo.reasonCodes.map(a => a.code), headerCodeone.reasonCodes.map(a => a.code))
        function pscToErrorTabName(pscErrorName) {
          if (pscErrorName == 'merchandise') return "Merchandise";
          if (pscErrorName == 'parties') return "Parties";
          return "Transport"

        }
        if (repeatedPSCCode && repeatedPSCCode.length) {
          warningListyy.push({ tab: pscToErrorTabName(headerCodeone.key), msg: `PSC Reason: Using the same PSC Reason twice will result in rejection - ${repeatedPSCCode.join(", ")}` });
        }
      }
    }
  }


//TODO: NET QTY-HTS UNIT
//TODO: ADD NET QTY
    var missingTariffEntryType = false;
    let invoiceIdx = 0
    for(var item  of  myobj.DescriptionOfMerchandise.entrySummaryInvoices){
      let exchangeRate = item?.currencyExchangeInfo?.exchangeRate
      let isUSDConversion = item?.currencyExchangeInfo?.toIsoCurrencyCode == "USD" && exchangeRate == 1;
      let invoiceId = item.invoiceId;
      let invoiceitemid = "(Invoice "+(''+(++invoiceIdx)).padStart(3, '0')+")";
     
      var targetblobject = validObjects_bl[item.invoiceId];
      const hasFreightValues = (parseFloat(item?.otherAdditions) > 0 || parseFloat(item.otherDeductions) > 0  ||  parseFloat(item.frieghtInsurance) > 0 ||  parseFloat(item.frieghtCharges)  > 0 ); // add other additions
    //   if((parseFloat(item.otherDeductions) > 0  &&  parseFloat(item.frieghtInsurance) > 0 &&  parseFloat(item.frieghtCharges)  > 0 ) && (getFreightDataValidationError("other deductions",
    //   item.frieghtCharges, item.frieghtInsurance,
    //   item.otherDeductions , item.invoiceAmount
    // ).length > 0)){
    //     warningListyy.push({tab:"Merchandise",msg:"Sum of freight charges, freight insurance and other deductions cannot be greater than invoice amount.", location: invoiceitemid,
    //     targetName_c: 'asdfg'+invoiceId, name:'other deductions'+invoiceId, invoice: `invoice-${invoiceId}`
    //   });
    //   }
      let intdddex = 0;
      for(var commercialItem of item.merchandiseLineItems){
        if(['cargoReleaseUpdate'].includes(allpropsaa?.updateType))continue;//no line item validation during BOL Update
        let merchlineitemidString =invoiceitemid+ " (Line item "+(''+(++intdddex)).padStart(3, '0')+")";
        let merchid = commercialItem.merchandiseId;
        validObjects_bl[commercialItem.merchandiseId] ={warningListyy:[]};
        var targetblobject = validObjects_bl[commercialItem.merchandiseId];
        //do regular validation
        let seenHTSList = [];
        const isTarget = window.location.href.includes("target")
        let commodityDuty = (commercialItem.merchandiseDuties ||[]).find(a=>a.isCommodityDuty==1)
        if(commodityDuty){
          if(exchangeRate){
            let dutyErrorMargin = Math.round(Math.abs(((commodityDuty.invoiceCurrencyValue||0) * exchangeRate) - (commodityDuty.enteredValue||0)))
            if((dutyErrorMargin> CURRENCY_CONVERSION_MATH_ERROR_MARGIN) && !isTarget){
                warningListyy.push({tab:"Merchandise",msg:`Entered Value: Conversion appears incorrect ${commodityDuty.invoiceCurrencyValue} * ${exchangeRate} = ${commodityDuty.enteredValue}, off by ${dutyErrorMargin}`, location: merchlineitemidString,
                targetName_c: 'adcvdtggt'+merchid, name:'enteredValue'+commodityDuty.merchandiseDutyId, invoice: `invoice-${invoiceId}`
              });

            }
          }
          // if(commodityDuty.enteredValue % 1 > 0 && !hasFreightValues && isUSDConversion){
          //   warningListyy.push({tab:"Merchandise",msg:`Entered Value: Should be a whole number (${commodityDuty.enteredValue}), off by ${(commodityDuty.enteredValue % 1).toFixed(3)}`, location: merchlineitemidString,
          //     targetName_c: 'adcvdtggt'+merchid, name:'enteredValue'+commodityDuty.merchandiseDutyId, invoice: `invoice-${invoiceId}`
          //   })
          // };
          if(commodityDuty.adjustedValue % 1 > 0 && hasFreightValues && !isUSDConversion){
            warningListyy.push({tab:"Merchandise",msg:`Entered Value: Should be a whole number (${commodityDuty.adjustedValue}), off by ${(commodityDuty.adjustedValue % 1).toFixed(3)}`, location: merchlineitemidString,
              targetName_c: 'adcvdtggt'+merchid, name:'adjustedValue'+commodityDuty.merchandiseDutyId, invoice: `invoice-${invoiceId}`
            })
          }
  
        }

        
        

        const currentCommodity = (commercialItem.merchandiseDuties||[]).find(aaa=> aaa?.isCommodityDuty == 1);
        const adjustedValueZeroIndex =(commercialItem.merchandiseDuties||[])[0]?.adjustedValue || 0;
        for(var dutyItem of  commercialItem.merchandiseDuties){
          let commodityEnteredValue  = parseFloat(currentCommodity?.adjustedValue) ||  parseFloat(currentCommodity?.enteredValue);
          if(!commodityEnteredValue || commodityEnteredValue < 1){
            commodityEnteredValue = parseFloat(currentCommodity?.enteredValue);
          }
          if(!getCommodityHTSOrPrimaryCommodity(dutyItem)){
            commodityEnteredValue = parseFloat(currentCommodity?.enteredValue);
          }
          if (hasFreightValues && !dutyItem.htsus.startsWith("9802")) {
            commodityEnteredValue = parseFloat(adjustedValueZeroIndex) || 0;
          } else if (dutyItem.enteredValue && (parseFloat(dutyItem.enteredValue) || 0) > 0) {
            commodityEnteredValue = parseFloat(dutyItem.enteredValue) || 0;
          }
          if(commodityEnteredValue<0){
            commodityEnteredValue=0;
          }
          if(isRail && parseFloat(dutyItem.hmf.fee) > 0){
            warningListyy.push({tab:"Merchandise",msg:"HMF not allowed for RAIL shipments", location: merchlineitemidString,
              targetName_c: 'adcvdtggt'+merchid, name:'hmf'+merchid, invoice: `invoice-${invoiceId}`
            });
          }
          if(!dutyItem.htsus){
            warningListyy.push({tab:"Merchandise",msg:"Missing HTS field", location: merchlineitemidString,
            targetName_c: 'adcvdtggt'+merchid, name:'htsus'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`
          });
            continue;
          } else {
            if(seenHTSList.includes(dutyItem.htsus.replaceAll(".","")) && !dutyItem.htsus.startsWith("9802")){
              warningListyy.push({tab:"Merchandise",msg:`HTS code: Repeated HTS '${dutyItem.htsus}''`, location: merchlineitemidString,
              targetName_c: 'adcvdtggt'+merchid, name:'htsus'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`
            });

            }
            seenHTSList.push(dutyItem.htsus.replaceAll(".",""));
          }
          
          var firsttwodigits = parseInt(dutyItem.htsus.substr(0,2))
          if(!dutyItem.htsDescription || dutyItem.htsDescription.trim().length<3){
            warningListyy.push({tab:"Merchandise",msg:"HTS Description missing", location: merchlineitemidString,
             targetName_c: 'adcvdtggt'+merchid, name:'htsDescription'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
          }
          if(!dutyItem.htsus.match(/\d+/g)){
            warningListyy.push({tab:"Merchandise",msg:"HTS: Must be 10 numeric digits '"+dutyItem.htsus+"'", location: merchlineitemidString,
             targetName_c: 'adcvdtggt'+merchid, name:'htsus'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`,
             priorityErrorFinalReview: true});
            continue;
          }
          let htsasnumbers = dutyItem.htsus.match(/\d+/g).join("");
          if(firsttwodigits >= 1 && firsttwodigits <= 97){
            if(htsasnumbers.length != 10){
              warningListyy.push({tab:"Merchandise",msg:"HTS: Must be 10 digits long '"+dutyItem.htsus+"'", location: merchlineitemidString,
               targetName_c: 'adcvdtggt'+merchid, name:'htsus'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`,
               priorityErrorFinalReview: true});
            }
          }
          if(firsttwodigits == 98 || firsttwodigits == 99){
            if(htsasnumbers.length != 10 && htsasnumbers.length != 8 ){
              warningListyy.push({tab:"Merchandise",msg:"HTS: Must be 10 or 8 digits long '"+dutyItem.htsus+"'", location: merchlineitemidString,
               targetName_c: 'adcvdtggt'+merchid, name:'htsus'+dutyItem.merchandiseDutyId,
               priorityErrorFinalReview: true});
            }
          }

          const skipFeeValidations  = ["COTTON_FEE"];

          for(let userFee of (dutyItem?.additionalDuties?.userFees||[])){
            if(userFee?.dutyType?.indexOf("_FEE") <= 0 || !userFee?.dutyType)continue;
            if(skipFeeValidations.includes(userFee.dutyType)) continue;
            if(feeIsZero(userFee)){
              warningListyy.push({tab:"Merchandise",msg:`${userFee.dutyType.replaceAll("_"," ")} is missing a value`, location: merchlineitemidString,
              targetName_c: 'adcvdtggt'+merchid, name:`feeIcons_FXEE${userFee.dutyType}${merchid}`,
              priorityErrorFinalReview: true});
            }
          }

          


          const expectedDutyValue = (
            0.01 *
              parseFloat(dutyItem.manifestQuantity.quantity) *
              (parseFloat(dutyItem?.specificRate) || 0) +
            commodityEnteredValue * parseFloat(dutyItem?.dutyRate) * 0.01 +
            0.00000000001 +
            0.01 *
              parseFloat(dutyItem.additionalQuantity?.quantity || 0) *
              (parseFloat(dutyItem?.otherRate) || 0)
          ).toFixed(2);
          
          const MAXIMUM_ERROR = 1;
          let dutyCalcIsCorrect = Math.abs(expectedDutyValue - (parseFloat(dutyItem?.duty) + 0.00000000001).toFixed(2)) < MAXIMUM_ERROR;
          if (dutyItem.dutyOverrideFlag != 1 && !dutyCalcIsCorrect && !ch82SetHtses.includes((dutyItem?.htsus ||"").replaceAll(".",""))) {
              console.log('commercialItexxm: ', commercialItem);
              const specificRateString =parseFloat(dutyItem?.specificRate)?`${dutyItem.manifestQuantity.quantity}*${dutyItem?.specificRate} + `:'';
              const otherRateString =parseFloat(dutyItem?.otherRate)?`${dutyItem.additionalQuantity.quantity}*${dutyItem?.otherRate} + `:'';
              warningListyy.push({
                tab: 'Merchandise',
                msg: `Duty: Calculation appears incorrect. Saw '${parseFloat(
                  dutyItem?.duty
                )}' but expected '${expectedDutyValue} 
              (${specificRateString}
                ${otherRateString}
                 ${commodityEnteredValue} * ${
                  parseFloat(dutyItem?.dutyRate) * 0.01
                })' 
               `,
                location: merchlineitemidString,
                warntype: 'warning',
                popupWarnFinalReview: true,
                targetName_c: 'adcvdtggt' + merchid,
                name: 'duty' + dutyItem.merchandiseDutyId,
                invoice: `invoice-${invoiceId}`,
              });
            
          }


          if(dutyItem.isCommodityDuty == 1 ){ //is commodity
            const metadataUnit1 = dutyItem.hsDataDtl?.unit1;
            const metadataUnit2 = dutyItem.hsDataDtl?.unit2;
            const manifestQtyUnit = dutyItem?.manifestQuantity?.units;
            const baseHts = dutyItem?.htsus?.slice(0,2)
            const isBaseUnder98 = parseInt(baseHts) <98 && parseInt(baseHts) > 0;
            let childHasSteelAluminium = false;
            commercialItem.merchandiseDuties.forEach((item, index)=>{
              if(!index)  return;
              if(steelAndAluminiumHts?.includes(item?.htsus?.replace(/\./g, "")));
              childHasSteelAluminium = true;
            });
            const additionalQuantityUnit = dutyItem?.additionalQuantity?.units;
            const hasManifestQuantityUnit = (manifestQtyUnit && !["NONE","NA","_BLANK_","N/A"].includes(manifestQtyUnit.toUpperCase()));
            const hasAdditionalQuantityUnit = (additionalQuantityUnit && !["NONE","NA","_BLANK_","N/A"].includes(additionalQuantityUnit.toUpperCase()));

            if(parseFloat(dutyItem.manifestQuantity.quantity) <=0 && hasManifestQuantityUnit){
              if(!isBaseUnder98){
                warningListyy.push({tab:"Merchandise",msg:`Net Quantity: Check that this value is correct. Is ${dutyItem.manifestQuantity.quantity}`, location: merchlineitemidString, warntype:'warning', popupWarnFinalReview: true,
                  targetName_c: 'adcvdtggt'+merchid, name:'manifestQuantity'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
                }
              }
            // if(!dutyItem.manifestQuantity.units ){
            //   warningListyy.push({tab:"Merchandise",msg:`Net Quantity Units: Cannot be blank`, location: merchlineitemidString,
            //   targetName_c: 'adcvdtggt'+merchid, name:'manifestQuantity'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
            // } 
            /*else if(myobj.DropDownValues.unitList){
              let validmanifestunit = myobj.DropDownValues.unitList.filter(a=>a.id!="PCS").find(a=>a.ediCode == dutyItem.manifestQuantity.units || a.id == dutyItem.manifestQuantity.units);
              if(!validmanifestunit){
                warningListyy.push({tab:"Merchandise",msg:`Net Quantity Units: Invalid unit '${dutyItem.manifestQuantity.units}'`,
                targetName_c: 'adcvdtggt'+merchid, name:'manifestQuantity'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});

              }
            }*/


            if(dutyItem?.hsDataDtl?.column1SpecificRate && 
              parseFloat(dutyItem?.hsDataDtl?.column1SpecificRate) != parseFloat(dutyItem?.specificRate) &&
              parseFloat(dutyItem?.hsDataDtl?.column2SpecificRate) != parseFloat(dutyItem?.specificRate) &&
              ["NA"].includes(commercialItem.productClaimCode)
              
              ){
              warningListyy.push({tab:"Merchandise",msg:`Duty Specific Rate: Expected '${dutyItem?.hsDataDtl?.column1SpecificRate}', but got '${dutyItem?.specificRate}'`, location: merchlineitemidString, warntype:'warning',
              targetName_c: 'adcvdtggt'+merchid, name:'duty'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
            }

            
            if(metadataUnit1 &&  manifestQtyUnit != metadataUnit1){
              warningListyy.push({tab:"Merchandise",msg:`Net Quantity Units: Expected '${metadataUnit1}', but got '${manifestQtyUnit || "NONE"}'`, location: merchlineitemidString, warntype:'warning',
              targetName_c: 'adcvdtggt'+merchid, name:'manifestQuantity'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
            }
            if(dutyItem.hsDataDtl?.htsNo && !metadataUnit1 && hasManifestQuantityUnit){
              warningListyy.push({tab:"Merchandise",msg:`Net Quantity Units: No unit expected, but got '${manifestQtyUnit || "NONE"}'`, location: merchlineitemidString, warntype:'warning',
              targetName_c: 'adcvdtggt'+merchid, name:'manifestQuantity'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
            }

            
            if(metadataUnit2 &&  additionalQuantityUnit != metadataUnit2){
              warningListyy.push({tab:"Merchandise",msg:`Additional Quantity Units: Expected '${metadataUnit2}', but got '${additionalQuantityUnit || "NONE"}'`, location: merchlineitemidString, warntype:'warning',
              targetName_c: 'adcvdtggt'+merchid, name:'additionalQuantity'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
            }
            if(dutyItem.hsDataDtl?.htsNo && !metadataUnit2 && hasAdditionalQuantityUnit){
              warningListyy.push({tab:"Merchandise",msg:`Additional Quantity Units: No unit expected, but got '${additionalQuantityUnit || "NONE"}'`, location: merchlineitemidString, warntype:'warning',
              targetName_c: 'adcvdtggt'+merchid, name:'additionalQuantity'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
            }

            

            if(parseFloat(dutyItem?.additionalQuantity?.quantity) && !dutyItem?.additionalQuantity?.units){
              warningListyy.push({tab:"Merchandise",msg:`Additional Net Quantity: Missing unit`,
              targetName_c: 'adcvdtggt'+merchid, name:'additionalQuantity'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
            }
            if(parseFloat(dutyItem.enteredValue) <=0){
              warningListyy.push({tab:"Merchandise",msg:`Entered Value: Must be greater than 0 but is ${dutyItem.enteredValue}`, location: merchlineitemidString,
              targetName_c: 'adcvdtggt'+merchid, name:'enteredValue'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`,priorityErrorFinalReview: true});
            }
   
            if(parseFloat(dutyItem.charges) < 0.01) warningListyy.push({tab:"Merchandise",msg:"Duty Item charges cannot be zero", location: merchlineitemidString,
             targetName_c: 'adcvdtggt'+merchid, name:'dutyitemcharges'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
            if(!dutyItem.enteredValue)warningListyy.push({tab:"Merchandise",msg:"Entered value: Must be defined", location: merchlineitemidString,
             targetName_c: 'adcvdtggt'+merchid, name:'enteredValue'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
            // if(parseFloat(dutyItem.mpf.fee) < 0.01) warningListyy.push({tab:"Merchandise",msg:"MPF fee cannot be zero", targetName_c: 'adcvdtggt'+merchid});
            // if(parseFloat(dutyItem.hmf.fee) < 0.01) warningListyy.push({tab:"Merchandise",msg:"HMF fee cannot be zero", targetName_c: 'adcvdtggt'+merchid});
          } else {
            //NON-commodity validations:
            const skipDutyForChinaList = ["99030133", "99030132", "99038869"];

            const currentHTS = (dutyItem?.htsus || "").replaceAll(".", "");
            
            const isCountryChina = commercialItem?.countryOfOrigin === "CN";
            const is99HTS = currentHTS.startsWith("99");
            const isDutyNotRequired = skipDutyForChinaList.includes(currentHTS);
            const hasNoDutyRate = (parseFloat(dutyItem?.dutyRate) || 0) <= 0;

            if(isCountryChina && is99HTS && !isDutyNotRequired && hasNoDutyRate){
              warningListyy.push({tab:"Merchandise",msg:"Duty rate: Expected a value for CN and CH 99, got "+dutyItem?.dutyRate, location: merchlineitemidString,
             targetName_c: 'adcvdtggt'+merchid, name:'dutyRate'+dutyItem.merchandiseDutyId, invoice: `invoice-${invoiceId}`});
            
            }
          }
        }
        //do adcvd validation
        for(var dutyItem of  commercialItem.merchandiseDuties){
          if(dutyItem.isCommodityDuty  == 2)continue;
          if(!dutyItem?.hsDataDtl?.adCvdApplicable || dutyItem?.hsDataDtl?.adCvdApplicable == 2)continue;
          var ignoreADCVD = (dutyItem.adcvd && dutyItem.adcvd.adcvdNotApplicable+"") == "1";
            if(ignoreADCVD){
              break;
            }
            let noadcvdvalues = !dutyItem.adcvd || (!dutyItem.adcvd.cvd && !dutyItem.adcvd.ad)  || (!Object.keys(dutyItem.adcvd.cvd || {}).length && !Object.keys(dutyItem.adcvd.ad || {}).length );
            if(noadcvdvalues) {
              
              targetblobject.warningListyy.push("Must fill any AD/CVD field, or mark not applicable");
              warningListyy.push({tab:"Merchandise", msg: "Must fill any AD/CVD field, or mark not applicable", location: merchlineitemidString,
              targetName_c: 'adcvdtggt'+merchid, invoice: `invoice-${invoiceId}`, priorityErrorFinalReview: true});
              continue;
            }
  
            var anyfilled = false;
            for(var adorcvd of ['ad','cvd']){
              if(!dutyItem.adcvd[adorcvd])continue;
              if(entryType != "03"){
                missingTariffEntryType = true;
              }
              if(dutyItem.adcvd[adorcvd].caseNo ||
                dutyItem.adcvd[adorcvd].claimCode ||
                (dutyItem.adcvd[adorcvd].caseDepositRate && parseFloat(dutyItem.adcvd[adorcvd].caseDepositRate)) ||
                  dutyItem.adcvd[adorcvd].caseRateCode||
                  (dutyItem.adcvd[adorcvd].dutyAmount && parseFloat(dutyItem.adcvd[adorcvd].dutyAmount))
                  ){
                    
                    anyfilled=true;
                  var adorcvdastext = adorcvd == 'ad' ? 'Antidumping' :'Countervailing'
                  if(!dutyItem.adcvd[adorcvd].caseNo){
                    warningListyy.push({tab:"Merchandise", msg: adorcvdastext+" case number: Must be defined", location: merchlineitemidString,
                    targetName_c: 'adcvdtggt'+merchid, invoice: `invoice-${invoiceId}`});
                    targetblobject.warningListyy.push(adorcvdastext+" case number: Must be defined");
                  }
                  if(!dutyItem.adcvd[adorcvd].claimCode){warningListyy.push({tab:"Merchandise", msg: adorcvdastext+"  bond/cash claim code: Must be defined", location: merchlineitemidString,
                  targetName_c: 'adcvdtggt'+merchid, invoice: `invoice-${invoiceId}`});
                  targetblobject.warningListyy.push(adorcvdastext+" bond/cash code: Must be defined");
                }
                  if(!dutyItem.adcvd[adorcvd].caseDepositRate){
                    warningListyy.push({tab:"Merchandise", msg: adorcvdastext+"  case deposit rate: Must be defined", location: merchlineitemidString,
                    targetName_c: 'adcvdtggt'+merchid, invoice: `invoice-${invoiceId}`});
                    targetblobject.warningListyy.push(adorcvdastext+" case deposit rate: Must be defined");
                  }
                  if(!dutyItem.adcvd[adorcvd].caseRateCode){warningListyy.push({tab:"Merchandise", msg: adorcvdastext+"  qualifier code: Must be defined", location: merchlineitemidString,
                  targetName_c: 'adcvdtggt'+merchid, invoice: `invoice-${invoiceId}`});
                  
                  targetblobject.warningListyy.push(adorcvdastext+" qualifier code: Must be defined");
                }
                  // if(!dutyItem.adcvd[adorcvd].specialValue)warningListyy.push({tab:"Merchandise", msg: adorcvdastext+"  special value: Must be defined"});
                  // if(!dutyItem.adcvd[adorcvd].specialQuantity)warningListyy.push({tab:"Merchandise", msg: adorcvdastext+"  special quantity: Must be defined"});
                  if(!dutyItem.adcvd[adorcvd].dutyAmount){
                    warningListyy.push({tab:"Merchandise", msg: adorcvdastext+" duty: Must be defined", location: merchlineitemidString,
                    targetName_c: 'adcvdtggt'+merchid, invoice: `invoice-${invoiceId}`});
                    targetblobject.warningListyy.push(adorcvdastext+" duty: Must be defined");
                  }
  
  
              }
              
            }
            if(!anyfilled){
              targetblobject.warningListyy.push("Must fill any AD/CVD field, or mark not applicable");
              warningListyy.push({tab:"Merchandise", msg: "Must fill any AD/CVD field, or mark not applicable", location: merchlineitemidString,
                targetName_c: 'adcvdtggt'+merchid, invoice: `invoice-${invoiceId}`,
                priorityErrorFinalReview: true });
            }
  
  
          
  
        }


        
        //PGA VALIDATION
        let pgasUnselectedIndex=-1;
        let seenunseenpgas =[]
        let esupdate = ['cargoReleaseUpdate',"entryUpdate"].includes(allpropsaa?.updateType);
        if(commercialItem.articleHeader !=  'X' && !_.get(myobj,"PSC.pscShipmentId") && !esupdate && !isWarehouseEntry(myobj.EntryTypeInfo)){
          for (var dutyItem of commercialItem.merchandiseDuties) {
            if(dutyItem.isCommodityDuty == 2)continue;
            for (let potentialpga of _.get(dutyItem, "hsDataDtl.pgaMetadata.tarriffPgaDetails", [])) {
              pgasUnselectedIndex++
              let isSelect=false;
              let listOfTypes = [];
              const selectedFormTypes = (commercialItem.pgaFlagInfos||[]).map(a=>a.formType||a.pgaType);

              if(!potentialpga.programDetails.find(a=>a.active==1)){
                isSelect=true;//No active programs to select :(
              }
              for(let oneselectedPga of selectedFormTypes){
                for(let onepotentialProgram of potentialpga.programDetails){
                  isSelect |= onepotentialProgram.formType == oneselectedPga;
                }
              }
              let uniqueid= potentialpga.programName+"__"+potentialpga.tariffCode+"__"+merchlineitemidString+"_"+invoiceId;
              if(!isSelect && seenunseenpgas.indexOf(uniqueid)<0){
                seenunseenpgas.push(uniqueid)
                let hasDisclaimPga = !!(commercialItem.pgaFlagInfos||[]).find(a=>a.formType=="DISCLAIM_PGA"||a.pgaType=="DISCLAIM_PGA")
                if(potentialpga.programName === "FDA" && hasDisclaimPga){
                  continue;
                }

                  warningListyy.push({
                    tab: "Merchandise", msg: `${potentialpga.programName}: Select a PGA`, location: merchlineitemidString,
                    targetName_c: 'adcvdtggt' + merchid, name: `pgaerrors${pgasUnselectedIndex}` + merchid, invoice: `invoice-${invoiceId}`,
                    priorityErrorFinalReview: true
                  });
                
              }
            }
          }
        }
        //END PGA VALIDATION


      }
    }
  
    if(missingTariffEntryType){
      warningListyy.push({tab:"Entry",msg:"Entry type should be 03 if AD/CVD applies"});

    }
  }


  //BOND, BOND VALIDATION
  if (myobj?.BondInfo && !myobj.BondInfo.bondWaiver) {
    for (let requiredValues of [
      // { key: "bondValue", description: "Bond Value" },
      { key: "bondType", description: "Bond Type" },
      { key: "suretyNumber", description: "Surety Number" },
    ]) {
      if(isblank(myobj.BondInfo[requiredValues.key])){
        warningListyy.push({tab:"BondValidationTab",msg:`${requiredValues.description}: Must be filled`,name:requiredValues.key,
        priorityErrorFinalReview: true});
        
      }
    }
  }


  // "{"modeOfTransport":"40","importDate":{"epochs":1554768000000},"exportDate":{"epochs":1551225600000},"arrivalDate":{"epochs":1554768000000},
  //"importingCarrier":"OOCL POLAND","tripInformation":"017E","vesselCode":"EGLV","foreignPortOfLadingCode":{"id":"42899","title":"Hamm, Nordrhein-Westfalen","masterSet":true},
  //"USportOfUnladingCode":{"id":"2811","title":"Oakland, CA","masterSet":true},"centralizedExaminationSite":"","nonAms":"","splitBill":""}"

  if(!myobj.TransportationInfo.modeOfTransport){
    warningListyy.push({tab:"Transport",msg:"Mode of Transport: Must be filled",name:'modeOfTransport'});
  }
  if(!(myobj.TransportationInfo.importDate && myobj.TransportationInfo.importDate.epochs && myobj.TransportationInfo.importDate.epochs > 0)){
    warningListyy.push({tab:"Transport",msg:"Import date: Must be filled",name:"importDate"});
  }
  if(!(myobj.TransportationInfo.exportDate && myobj.TransportationInfo.exportDate.epochs && myobj.TransportationInfo.exportDate.epochs > 0)){
    warningListyy.push({tab:"Transport",msg:"Export date: Must be filled",name:"exportDate"});
  }
  if(!(myobj.TransportationInfo.arrivalDate && myobj.TransportationInfo.arrivalDate.epochs && myobj.TransportationInfo.arrivalDate.epochs > 0)){
    warningListyy.push({tab:"Transport",msg:"Arrival date: Must be filled",name:"arrivalDate"});
  }
  if(!myobj.TransportationInfo.tripInformation && isOcean){
    warningListyy.push({tab:"Transport",msg:"Trip Information: Must be filled",name:"tripInformation"});
  }

  if(!myobj.TransportationInfo.truckNo && isTruck){
    // warningListyy.push({tab:"Transport",msg:"Truck Number: Must be filled",name:"truckNo"});
  }
  if(!myobj.TransportationInfo.flightNo && isAir){
    warningListyy.push({tab:"Transport",msg:"Flight Number: Must be filled",name:"flightNo"});
  }
  let hasCarrier = typeof myobj.TransportationInfo.importingCarrier == 'string'?myobj.TransportationInfo.importingCarrier:myobj.TransportationInfo.importingCarrier?.title;
  if(!hasCarrier && isOcean){
    warningListyy.push({tab:"Transport",msg:"Vessel Name: Must be filled",name:"importingCarrier",
    priorityErrorFinalReview: true});
  }
  if( !hasCarrier && isAir && false){
    warningListyy.push({tab:"Transport",msg:"Conveyance Name: Must be filled",name:"importingCarrier"});
  }
  if(isOcean){
    if(!(myobj.TransportationInfo.foreignPortOfLadingCode && myobj.TransportationInfo.foreignPortOfLadingCode.id)){
      warningListyy.push({tab:"Transport",msg: "Foreign port of lading: Must be filled",name:"foreignPortOfLadingCode"});
    }
  }
  if(!(myobj.TransportationInfo.USportOfUnladingCode && myobj.TransportationInfo.USportOfUnladingCode.id)){
    warningListyy.push({tab:"Transport",msg: "US port of unlading: Must be filled",name:"USportOfUnladingCode"
  });
  }
  if(!myobj.Importer.usStateOfDestCode){
    warningListyy.push({tab:"Parties",msg: "State of ultimate destination: Must be filled",name:"usStateOfDestCode"
  });
  }
  if(myobj.Importer.headerParties && !document.getElementById("PSCinProgressYes")){
    const allPartiesUsed = (myobj.Importer.headerParties || []).map(a=>a.headerPartyType)
    for(let requiredParty of  ['MANUFACTURER', 'BUYER', 'SELLER', 'CONSOLIDATOR']){
      if(["CONSOLIDATOR"].includes(requiredParty))continue;
      if(!allPartiesUsed.includes(requiredParty)){
        warningListyy.push({tab:"Parties",msg: `Warning: Shipment is missing header party ${requiredParty}`});
      }
    }
    let consigneeId = myobj.Importer?.consignee?.consigneeId || myobj.Importer.headerParties.find(a=>a.headerPartyType=="CONSIGNEE")?.headerId;
    let importerId =  myobj.Importer?.importer?.importerId || myobj.Importer.headerParties.find(a=>a.headerPartyType=="IMPORTER")?.headerId;
    for(let headerParty of [...myobj.Importer.headerParties,{...myobj.Importer.consignee,headerId: consigneeId, headerPartyType:"CONSIGNEE"},{...myobj.Importer.importer,headerId: importerId, headerPartyType:"IMPORTER"}]){
      let myCountry =  (headerParty?.addressInfo?.COUNTRY_CODE ||"").toUpperCase();
      let noPostalValidation = true;
      let noStateValidation = true;
      if(["US","CN","CA"].includes(myCountry))noPostalValidation=false;
      if(["US","CA","MX"].includes(myCountry))noStateValidation=false;
      if(["CN"].includes(myCountry) && headerParty.headerPartyType!="MANUFACTURER")noPostalValidation=true;
      for (let validationX of [
        { field: "CITY", humanLanguageVersion: "CITY", uiReference: "CityValidationKK" },
        { field: "COUNTRY_CODE", humanLanguageVersion: "COUNTRY", uiReference: "CurrentCountryValidationKK", priorityErrorFinalReview:true  },
        { field: "POSTAL_CODE", humanLanguageVersion: "POSTAL CODE/ZIP", uiReference: "PostalCodeValidationKK" },
        { field: "STREET_NAME", humanLanguageVersion: "ADDRESS 1", uiReference: "StreetNameValidationKK" },
        { field: "COUNTRY_SUB_ENTITY", humanLanguageVersion: "STATE", uiReference: "StateValidationKK" }
      ]) {
        if(validationX.field == "POSTAL_CODE" && noPostalValidation)continue;
        if(validationX.field == "COUNTRY_SUB_ENTITY" && noStateValidation)continue;
        if (!((headerParty?.addressInfo||{})[validationX.field] || "").trim() && headerParty.sameAs != 1) {
          if(validationX?.field === "STREET_NAME" && (headerParty?.addressInfo||{})["STREET_NUMBER"]) {
            // do nothing
          }else{
          warningListyy.push({
            tab: "Parties", msg: `${headerParty.headerPartyType}: ${headerParty.name} is missing ${validationX.humanLanguageVersion}`,
            name: `${validationX.uiReference}${headerParty.headerId}`,
            priorityErrorFinalReview: validationX.priorityErrorFinalReview
          });
        }
        }

      }
      if(!headerParty.name){
        warningListyy.push({
          tab: "Parties", msg: `${headerParty.headerPartyType}: Has no name`,
          name: `manufacturerName${headerParty.headerId}`
        });

      }
      if(headerParty.headerPartyType == "MANUFACTURER" && (!headerParty.mId || !headerParty.mId.trim())){
        warningListyy.push({tab:"Parties",msg: `Manufacturer Id: ${headerParty.name} is missing a manfacturer Id`,
        name:"manufacturerId"+headerParty.headerId});
      }
      if(headerParty.headerPartyType === "MANUFACTURER" && headerParty?.addressInfo?.COUNTRY?.toUpperCase() === "CHINA" && !isDisabled('importerSection',false,allpropsaa)){
        for(let oneError of zipCodeValidator(headerParty?.addressInfo?.COUNTRY, headerParty.addressInfo.POSTAL_CODE)){
          warningListyy.push({tab:"Parties",msg: oneError(headerParty.name),
          name:"manufacturerChinaPostalCode"+headerParty.headerId, priorityErrorFinalReview:true});

        }
      }
    }
  }

  let importerInfo =_.get(myobj,"Importer.importer.importerIdInfo",{});
  let consigneeInfo =_.get(myobj,"Importer.consignee.consigneeIdInfo",{});
  for(let infoObject of [{name:"Consignee",obj:consigneeInfo},{name:"Importer",obj:importerInfo}]){
    if(!infoObject.obj.idtype){
      warningListyy.push({tab:"Parties",msg: `${infoObject.name} ID or ID Type is empty. Ensure customer profile has the right details.`,
      name: `${infoObject.name.toLowerCase()}idErrorErrorType`});

    } else {
        let validationObject = idOptionsvvValidation.find((a)=>a.id == infoObject.obj.idtype);
        let regexp = new RegExp(validationObject.formatRegex);
        if(!regexp.test(infoObject.obj.idnumber)){
          warningListyy.push({tab:"Parties",msg: `${infoObject.name} Id: Should follow format of ${validationObject.formatDescription}`});
        }
    }
  }

  
  if(myobj.EntryTypeInfo.summaryDate.epochs && myobj.TransportationInfo.importDate.epochs){
    let entryDate = new Date(myobj.EntryTypeInfo.summaryDate.epochs).getUTCDate()
    let entryMonth = new Date(myobj.EntryTypeInfo.summaryDate.epochs).getUTCMonth()+1
    let entryYear = new Date(myobj.EntryTypeInfo.summaryDate.epochs).getUTCFullYear()
    let newEntryDate = new Date(entryMonth +"/"+ entryDate +"/"+ entryYear);
    //console.log("newEntryDate", newEntryDate);

    let transportationDate = new Date(myobj.TransportationInfo.importDate.epochs).getUTCDate()
    let transportationMonth = new Date(myobj.TransportationInfo.importDate.epochs).getUTCMonth()+1
    let transportationYear = new Date(myobj.TransportationInfo.importDate.epochs).getUTCFullYear()
    let newTransportationDate = new Date(transportationMonth +"/"+ transportationDate +"/"+ transportationYear);
    //console.log("newTransportationDate", newTransportationDate);

    // if(newEntryDate < newTransportationDate){
    //   warningListyy.push({tab:"Transport",msg: "Import Date and Entry Date: Import Date cannot be greater than entry date", name:'importDate'});
    //   warningListyy.push({tab:"Entry",msg: "Import Date and Entry Date: Import Date cannot be greater than entry date", name:'summaryDate', shown: false});
    // } 
  }
  


  if(!myobj.EntryTypeInfo.summaryDate || Object.keys(myobj.EntryTypeInfo.summaryDate).length == 0){
    warningListyy.push({tab:"Entry",msg: "Entry Date: Must be filled"});
  }
  let releaseDate = _.get(myobj,"EntryTypeInfo.releaseDate.epochs",0);
  let pspd = _.get(myobj,"EntryTypeInfo.primaryStatementPrintDate.epochs",0);
  if(pspd<=0){
    let isIndividual = myobj.EntryTypeInfo.statementPaymentType == "INDIVIDUAL";
    if(isIndividual){
      //Do nothing
    } else {
      warningListyy.push({tab:"Entry",msg: "Preliminary Statement Print Date: Must be filled", name:'primaryStatementPrintDate',
      priorityErrorFinalReview: true
    });
    }
  } else if(releaseDate > 0){
    if(pspd<=releaseDate){
      // warningListyy.push({tab:"Entry",msg: "Preliminary Statement Print Date: Should be a future date of release date", name:'primaryStatementPrintDate'});
    }
  } else {
    if(pspd<=myobj.EntryTypeInfo.summaryDate.epochs){
      warningListyy.push({tab:"Entry",msg: "Preliminary Statement Print Date: Should be a future date of entry date", name:'primaryStatementPrintDate'});
    }
  }

  if(!isBusinessDayMemoized(new Date(myobj.EntryTypeInfo.primaryStatementPrintDate.epochs)) ){
    warningListyy.push({tab:"Entry",msg: "Preliminary Statement Print Date: Falls on Holiday or Weekend", name:'primaryStatementPrintDate'});
  }
  if(!myobj.EntryTypeInfo.entryType){
    warningListyy.push({tab:"Entry",msg: "Entry Type: Must be filled"});
  }
  if(!myobj.EntryTypeInfo.countryOfExport){
    warningListyy.push({tab:"Entry",msg: "Country of Export: Must be filled"});
  }
  if(!myobj.EntryTypeInfo.portCode || !myobj.EntryTypeInfo.portCode.id){
    warningListyy.push({tab:"Entry",msg: "Port of entry Code: Must be filled", name:'portCode',
    priorityErrorFinalReview: true});
  }
  if(!myobj.EntryTypeInfo.statementPaymentType){
    warningListyy.push({tab:"Entry",msg: "Statement payment type: Must be filled", priorityErrorFinalReview: true});
  }
  let monthlystatement = (myobj.EntryTypeInfo.statementPaymentType+"").toLowerCase().includes("month");

  let hasreleasedate = _.get(myobj,"EntryTypeInfo.releaseDate.epochs",0) > 1000;
  let referencedateforperiodicstatementMonth = hasreleasedate?_.get(myobj,"EntryTypeInfo.releaseDate.epochs"):_.get(myobj,"EntryTypeInfo.summaryDate.epochs");
  if(!hasreleasedate && monthlystatement && !isNaN(myobj.EntryTypeInfo.periodicStatementMonths) && referencedateforperiodicstatementMonth && 
    (myobj.EntryTypeInfo.periodicStatementMonths != ((new Date(referencedateforperiodicstatementMonth).getUTCMonth()+1)%12 + 1) &&
    myobj.EntryTypeInfo.periodicStatementMonths != ((new Date(referencedateforperiodicstatementMonth).getUTCMonth()+1)%12)//also the current month
    )
  ){
    warningListyy.push({tab:"Entry",warntype:'warning', 
    msg: `Statement Month: Preliminary Statement Month ${monthNumberToMonth(myobj.EntryTypeInfo.periodicStatementMonths)} 
      is neither the same month or a single month in the future of the ${hasreleasedate?'Release date':'Entry date month'} 
      (${monthNumberToMonth(new Date(referencedateforperiodicstatementMonth).getUTCMonth()+1)}).`});
  }


  //HEAder bol info
  if(!getQueryVariable("onlyOneShipment")){
    if(myobj.BOLInfo.bol.boltype=="HOUSE_BOL" && (isTruck || isRail)){
      warningListyy.push({tab:"Bol",msg: `House Bol: Not allowed for ${isTruck?'truck':''} ${isRail?'rail':''} shipments`});

    }
    let bolunit = (myobj.BOLInfo.manifestQuantity.units||"").toUpperCase();
    if(!(myobj.DropDownValues.unitList||[]).find(a=> a.id == bolunit || a.shortDesc == bolunit || a.ediCode == bolunit)){
      warningListyy.push({tab:"Bol",msg: `Bol Manifest Quantity Unit: '${bolunit}' is invalid `,name:'manifestQuantityUnits'});
    }

  }
  let itDateError = false;

  for (let itNumber of (!getQueryVariable("onlyOneShipment") ? [myobj.BOLInfo?.itNumber] :
    myobj?.BOLInfo?.engineBolInfo?.engineBolRecord?.filter(aaaa => Object.keys(aaaa)?.includes("itNumber") || (aaaa.intakeShipmentId+"").indexOf("KX-")==0)?.map(aaaa => aaaa.itNumber)
    )) {
    if (hasFieldKN(itNumber)) {
      if (itNumber?.length > 12) {
        warningListyy.push({ tab: "Bol", msg: `IT Number: Must be less than 13 characters`, name: 'itNumber', priorityErrorFinalReview: true });
      } else if (!itNumber.match(/^[a-z0-9]+$/gi)) {
        warningListyy.push({ tab: "Bol", msg: `IT Number: Must be alphanumeric`, name: 'itNumber' });
      }
      if (!hasFieldKN(myobj.BOLInfo?.itDate?.epochs) && !itDateError) {
        itDateError=true;
        warningListyy.push({ tab: "Bol", msg: `IT Date: Must be present if IT Number is present`, name: 'itDate' });

      }
    }
    if (hasFieldKN(myobj.BOLInfo?.itDate?.epochs)) {
      if (!hasFieldKN(itNumber)) {
        warningListyy.push({ tab: "Bol", msg: `IT Number: Must be present if IT Date is present`, name: 'itNumber', priorityErrorFinalReview: true });
      }
      if (hasFieldKN(myobj?.EntryTypeInfo?.summaryDate?.epochs)) {
        if (Math.abs(myobj?.EntryTypeInfo?.summaryDate?.epochs - myobj.BOLInfo?.itDate?.epochs) > (1000 * 60 * 60 * 24 * 366)) {
          warningListyy.push({ tab: "Bol", msg: `IT Date: Must be within 12 months of entry date`, name: 'itDate' });

        }
      }

    }
  }


  // DeclarationSection:
  if(!(myobj.DeclarationSection.actualOwnerFlag == "1" || myobj.DeclarationSection.purchaserFlag == "1")){
    warningListyy.push({tab:"Sign",msg: "Must declare if you are the actual owner or purchaser"});

  }
  if(!(myobj.DeclarationSection.trueInvoiceFlag == "1" || myobj.DeclarationSection.bestInvoiceFlag == "1")){
    warningListyy.push({tab:"Sign",msg: "Must declare invoice receipt"});

  }

  //server warnings!
  let serverwarns = _.get(myobj,"FieldValidation.serverwarnings_tm",[]);
  for(let oneserverwarn of serverwarns){
    let tab = "ALLTABS";
    if(oneserverwarn.includes("House Bill of lading"))tab="Bol";
    warningListyy.push({tab:tab,msg: oneserverwarn});

  }

  for(let onewarning of warningListyy){
    validObjects_bl[onewarning.tab+"qwqr"+onewarning.name]=[onewarning.msg];
  }
  warningListyy.sort((a,b) =>{return (a.location+"").localeCompare(b.location+"");})
  window.LAST_WARNING_FF = {whennnn: Date.now(), warnings : warningListyy, validObjects_bl : validObjects_bl}
  return {...window.LAST_WARNING_FF,whennnn:null};
}

export default function FieldValidationReducer(state = initialState, action) {
  
  switch (action.type) {
    case 'INITIALIZE_WARNINGS': {
      return Object.assign({}, state,  validateFormff(action.payload,action.allpropsaa) )
    }
    case 'INITIALIZE_SERVER_WARNINGS':{
      return Object.assign({}, state,  { ...action.payload} )
    }
    case 'INITIALIZE_VALUES_FIELD_VALIDATION': {
     return Object.assign({}, state, { ...action.payload })
    }
    case 'RESET_FIELD_WARNINGS': {
      return Object.assign({}, state, { census_warnings: null })
    }
    case 'UPDATE_FIELD_WARNINGS': {
      const census_warnings = state.census_warnings ? Object.assign(state.census_warnings) : [];
      census_warnings[action.warnings.code+'_'+action.warnings.merchandiseId] = action.warnings;
      return Object.assign({}, state, { census_warnings: census_warnings })
    }
    case 'UPDATE_FIELD_VALIDATION_OBJECT': {
      let newFields = state.fields.slice()
      let index = newFields.findIndex((el) => {
        return (el.id === action.field.id && el.merchandiseId === action.field.merchandiseId)
      });
      newFields[index] = action.field
      return Object.assign({}, state, { fields: newFields })
    }
    default:
      return state
  }
}



  const getFreightDataValidationError = (field, frieghtCharges, frieghtInsurance, otherDeductions, invoiceAmount) => {

  let errors = [];
  let isblank = (str)=>{
    if(typeof str !== "string")return false;
    return !str || str.trim() === ""
  }
  
  if (isblank(frieghtCharges)) {
    frieghtCharges = 0.00
  }
  if (isblank(frieghtInsurance)) {
    frieghtInsurance = 0.00
  }
  if (isblank(otherDeductions)) {
    otherDeductions = 0.00
  }
  if (isblank(invoiceAmount)) {
    invoiceAmount = 0.00
  }


  if (parseFloat(frieghtCharges) + parseFloat(frieghtInsurance) + parseFloat(otherDeductions) > parseFloat(invoiceAmount)) {
    errors.push("Sum of freight charges, freight insurance and other deductions cannot be greater than invoice amount.");

  }

  return errors;
};